/*
 * Texte der Junior Mini Company (Anforderung #92). Eingebunden in `./index.js`
 * nach den großen Sprachdateien, wie `courses.js` — hier steht nur, was es
 * dort noch nicht gibt.
 */

const de = {
	'Junior Mini Companies': 'Junior Mini Companies',
	'Junior Mini Company': 'Junior Mini Company',
	'Open Junior Mini Company': 'Junior Mini Company öffnen',
	'New Junior Mini Company': 'Neue Junior Mini Company',
	'JMC status draft': 'Entwurf',
	'JMC status submitted': 'Zur Prüfung eingereicht',
	'JMC status active': 'Aktiv',
	'JMC status rejected': 'Zurückgegeben',
	'2nd grade': '2. Klasse',
	'3rd grade': '3. Klasse',
	'4th grade': '4. Klasse',
	'Mixed-age class': 'altersübergreifende Klasse',
	Principal: 'Direktor:in',
	'Class teacher': 'Klassenlehrer:in',
	'Leisure-time educator': 'Freizeitpädagog:in',
	'Music teacher': 'Musiklehrer:in',
	'Technology and design teacher': 'Technik- und Designlehrer:in',
	male: 'männlich',
	female: 'weiblich',
	'Junior Mini Company created': 'Junior Mini Company angelegt',
	'Child added': 'Kind eingetragen',
	'Child changed': 'Kind geändert',
	'Child removed': 'Kind entfernt',
	'Consent forms uploaded': 'Einverständniserklärungen hochgeladen',
	'Submitted for approval': 'Zur Prüfung eingereicht',
	'Approved by the state administration': 'Von der Landesadministration freigegeben',
	'Returned by the state administration': 'Von der Landesadministration zurückgegeben',
	'Teacher added': 'Lehrkraft hinzugefügt',
	'Invited teacher registered': 'Eingeladene Lehrkraft hat sich registriert',
	'Teacher removed': 'Lehrkraft ausgetragen',
	'Invitation withdrawn': 'Einladung zurückgezogen',
	'Certificates generated': 'Zertifikate erzeugt',
	'Consent form (parents)': 'Einverständniserklärung (Eltern)',
	'One per child, signed by a parent or guardian. Afterwards scan all of them into one PDF and upload it below.':
		'Eine je Kind, unterschrieben von einem Elternteil oder einer erziehungsberechtigten Person. Danach alle zusammen in eine PDF-Datei einscannen und unten hochladen.',
	'Share certificate (5 euros)': 'Anteilsschein (5 Euro)',
	'For people who take a financial stake in the Junior Mini Company — for example parents or grandparents.':
		'Für Personen, die sich finanziell an der Junior Mini Company beteiligen – zum Beispiel Eltern oder Großeltern.',
	'Questionnaire for the children': 'Fragebogen für die Kinder',
	'Questionnaire for pupils aged 8 to 10 at the end of the programme.':
		'Fragebogen für Schüler:innen von 8 bis 10 Jahren zum Abschluss des Programms.',

	// Liste der Lehrkraft
	'The Junior Mini Company is the primary-school version of the Junior Company. You do everything here: create it, enter the children, upload the consent forms and submit it to your state administration for approval.':
		'Die Junior Mini Company ist die Volksschul-Variante der Junior Company. Sie erledigen hier alles selbst: anlegen, Kinder eintragen, Einverständniserklärungen hochladen und bei Ihrer Landesadministration zur Freigabe einreichen.',
	'You have not created a Junior Mini Company yet.': 'Sie haben noch keine Junior Mini Company angelegt.',
	'A Junior Mini Company can only be created at a primary school (Volksschule). Your school is: {{school}}.':
		'Eine Junior Mini Company kann nur an einer Volksschule angelegt werden. Ihre Schule: {{school}}.',
	'Please assign yourself to a school in your profile first.': 'Bitte ordnen Sie sich zuerst in Ihrem Profil einer Schule zu.',
	Children: 'Kinder',
	'Name of the Junior Mini Company': 'Name der Junior Mini Company',
	'Description of the business activity': 'Beschreibung der Geschäftstätigkeit',
	'Year group of the pupils': 'Jahrgang der Schüler:innen',
	'Your role in the class': 'Ihre Rolle in der Klasse',
	'What do the children produce or sell? A few sentences are enough.':
		'Was stellen die Kinder her oder verkaufen sie? Ein paar Sätze genügen.',
	'Please fill in all fields.': 'Bitte füllen Sie alle Felder aus.',
	'The Junior Mini Companies could not be loaded.': 'Die Junior Mini Companies konnten nicht geladen werden.',

	// Ansicht einer JMC (Lehrkraft)
	'The Junior Mini Company could not be loaded.': 'Die Junior Mini Company konnte nicht geladen werden.',
	'Back to the list': 'Zurück zur Liste',
	'1. Details': '1. Angaben',
	'2. Children': '2. Teilnehmende Kinder',
	'3. Downloads': '3. Unterlagen zum Herunterladen',
	'4. Consent forms': '4. Einverständniserklärungen',
	'5. Submit': '5. Einreichen',
	Teachers: 'Lehrkräfte',
	'JMC certificates': 'Zertifikate',
	'JMC step created': 'Angelegt',
	'JMC step children': 'Kinder eingetragen',
	'JMC step consent': 'Einverständniserklärungen',
	'JMC phase completion': 'Abschluss',
	'Edit details': 'Angaben bearbeiten',
	'Add child': 'Kind hinzufügen',
	'First name': 'Vorname',
	'Last name': 'Nachname',
	'No child entered yet. Add each participating child with the + button.':
		'Noch kein Kind eingetragen. Tragen Sie jedes teilnehmende Kind mit dem +-Knopf ein.',
	'Remove child': 'Kind entfernen',
	'Remove {{name}} from the list?': '{{name}} aus der Liste entfernen?',
	'All consent forms together as one PDF file (max. 10 MB). A new upload replaces the previous file.':
		'Alle Einverständniserklärungen zusammen als eine PDF-Datei (höchstens 10 MB). Ein neuer Upload ersetzt die bisherige Datei.',
	'Upload PDF': 'PDF hochladen',
	'Use the template for this:': 'Verwenden Sie dafür die Vorlage:',
	'Download consent form template': 'Einverständniserklärung herunterladen',
	'Junior Mini Companies are deleted with the annual reset of the database. Please download the certificates beforehand.':
		'Junior Mini Companies werden mit dem jährlichen Zurücksetzen der Datenbank gelöscht. Bitte laden Sie die Zertifikate vorher herunter.',
	'Replace PDF': 'PDF ersetzen',
	'Uploaded on {{date}}': 'Hochgeladen am {{date}}',
	'No file uploaded yet.': 'Noch keine Datei hochgeladen.',
	'Only PDF files are allowed.': 'Erlaubt sind nur PDF-Dateien.',
	'The file is larger than 10 MB.': 'Die Datei ist größer als 10 MB.',
	'Submit the Junior Mini Company to your state administration?':
		'Junior Mini Company bei Ihrer Landesadministration einreichen?',
	'While it is being checked, nothing can be changed. Once it is approved, the details and the list of children are fixed.':
		'Während der Prüfung lässt sich nichts ändern. Nach der Freigabe sind Angaben und Kinderliste festgeschrieben.',
	'Still missing:': 'Es fehlt noch:',
	'Ready to submit. The state administration checks the Junior Mini Company and activates it.':
		'Bereit zum Einreichen. Die Landesadministration prüft die Junior Mini Company und schaltet sie frei.',
	'Submitted on {{date}}. The state administration is checking the Junior Mini Company — until then nothing can be changed.':
		'Eingereicht am {{date}}. Die Landesadministration prüft die Junior Mini Company – bis dahin lässt sich nichts ändern.',
	'Approved on {{date}}. The Junior Mini Company is active.':
		'Freigegeben am {{date}}. Die Junior Mini Company ist aktiv.',
	'Returned by the state administration:': 'Von der Landesadministration zurückgegeben:',
	'Please make the changes and submit again.': 'Bitte ändern Sie die Angaben und reichen Sie erneut ein.',
	'Since the approval, the details and the list of children can no longer be changed.':
		'Seit der Freigabe lassen sich Angaben und Kinderliste nicht mehr ändern.',
	'Delete Junior Mini Company': 'Junior Mini Company löschen',
	'Delete „{{name}}“? The children and the uploaded file are deleted too.':
		'„{{name}}“ löschen? Die eingetragenen Kinder und die hochgeladene Datei werden mitgelöscht.',
	'All teachers of this Junior Mini Company have the same rights.':
		'Alle Lehrkräfte dieser Junior Mini Company haben dieselben Rechte.',
	'Add teacher': 'Lehrkraft hinzufügen',
	'E-mail address of the teacher': 'E-Mail-Adresse der Lehrkraft',
	'If the teacher already has an account at your school, they are added straight away. Otherwise they receive an invitation to register.':
		'Hat die Lehrkraft schon ein Konto an Ihrer Schule, wird sie sofort eingetragen. Sonst bekommt sie eine Einladung zur Registrierung.',
	'Invitation sent': 'Einladung verschickt',
	'Withdraw invitation': 'Einladung zurückziehen',
	'Remove teacher': 'Lehrkraft austragen',
	'Leave Junior Mini Company': 'Junior Mini Company verlassen',
	Leave: 'Verlassen',
	'Remove {{name}} from this Junior Mini Company?': '{{name}} aus dieser Junior Mini Company austragen?',
	'Leave this Junior Mini Company? You will no longer see it.':
		'Diese Junior Mini Company verlassen? Sie sehen sie danach nicht mehr.',
	'(you)': '(Sie)',
	'Role not set': 'Rolle nicht angegeben',
	'Generate certificates': 'Zertifikate erzeugen',
	'Download certificates': 'Zertifikate herunterladen',
	'One page per child with first and last name, the Junior Mini Company, the school, the place of the school and today’s date. Your state administration is informed.':
		'Eine Seite je Kind mit Vor- und Nachname, Junior Mini Company, Schule, Ort der Schule und dem heutigen Datum. Ihre Landesadministration wird informiert.',
	'Generated on {{date}}.': 'Erzeugt am {{date}}.',
	'Certificates are available once the state administration has approved the Junior Mini Company.':
		'Zertifikate gibt es, sobald die Landesadministration die Junior Mini Company freigegeben hat.',
	'Generate the certificates now?': 'Zertifikate jetzt erzeugen?',
	'The list of children can no longer be changed, so the certificates are generated once. Your state administration receives a short notice.':
		'Die Kinderliste lässt sich nicht mehr ändern, deshalb werden die Zertifikate einmal erzeugt. Ihre Landesadministration bekommt eine kurze Info.',
	Generate: 'Erzeugen',
	'No entries yet.': 'Noch keine Einträge.',

	// Verwaltung
	'Name of the school': 'Name der Schule',
	'School type': 'Schultyp',
	'Federal state': 'Bundesland',
	'Children and consent forms (one PDF)': 'Kinder und Einverständniserklärungen (eine PDF-Datei)',
	'Search Junior Mini Company or school…': 'Junior Mini Company oder Schule suchen …',
	Approve: 'Freigeben',
	'Return': 'Zurückgeben',
	'Approve Junior Mini Company?': 'Junior Mini Company freigeben?',
	'The teachers are informed by e-mail. Afterwards the details and the list of children are fixed.':
		'Die Lehrkräfte bekommen eine E-Mail. Danach sind Angaben und Kinderliste festgeschrieben.',
	'Return Junior Mini Company?': 'Junior Mini Company zurückgeben?',
	'The teachers receive your reason by e-mail and can change the details and submit again.':
		'Die Lehrkräfte bekommen Ihre Begründung per E-Mail und können ändern und erneut einreichen.',
	'Approved.': 'Freigegeben.',
	'Returned to the teachers.': 'An die Lehrkräfte zurückgegeben.',
	'Submitted on': 'Eingereicht am',
	State: 'Bundesland',
	'Year group': 'Jahrgang',
}

const enOverrides = {
	'JMC status draft': 'Draft',
	'JMC status submitted': 'Submitted for review',
	'JMC status active': 'Active',
	'JMC status rejected': 'Returned',
	'1. Details': '1. Details',
	Return: 'Return',
	'JMC certificates': 'Certificates',
	'JMC step created': 'Created',
	'JMC step children': 'Children entered',
	'JMC step consent': 'Consent forms',
	'JMC phase completion': 'Completion',
	'Submitted on': 'Submitted on'
}

export const miniCompaniesGer = de
export const miniCompaniesEn = Object.fromEntries(Object.keys(de).map(key => [key, enOverrides[key] ?? key]))
